var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckedReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 5.5,
    fill: "#CACDD0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 5.5,
    stroke: "#CACDD0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99984 5.33301C7.2665 5.33301 6.67317 5.93301 6.67317 6.66634L6.6665 17.333C6.6665 18.0663 7.25984 18.6663 7.99317 18.6663H11.2796L10.2678 17.6545C9.42164 16.8084 9.42164 15.4366 10.2678 14.5904C11.1139 13.7443 12.4858 13.7443 13.3319 14.5904L13.9051 15.1636L16.9344 12.1343C17.0573 12.0114 17.1913 11.9063 17.3332 11.8191V9.88634C17.3332 9.53301 17.1932 9.19301 16.9398 8.94634L13.7198 5.72634C13.4732 5.47301 13.1332 5.33301 12.7798 5.33301H7.99984ZM12.6665 9.33301V6.33301L16.3332 9.99967H13.3332C12.9665 9.99967 12.6665 9.69967 12.6665 9.33301ZM18.9379 14.1377C19.1983 13.8774 19.1983 13.4553 18.9379 13.1949C18.6776 12.9346 18.2555 12.9346 17.9951 13.1949L13.9051 17.2849L12.2712 15.6511C12.0109 15.3907 11.5888 15.3907 11.3284 15.6511C11.0681 15.9114 11.0681 16.3335 11.3284 16.5939L13.4337 18.6991C13.6941 18.9595 14.1162 18.9595 14.3765 18.6991L18.9379 14.1377Z",
    fill: "#565A5E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckedReport);
export default __webpack_public_path__ + "static/media/icon-checked-report.4c7385561ca6d8b39fb27be4593f7ae0.svg";
export { ForwardRef as ReactComponent };